///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep } from "lodash";

import HeaderCell from "../../components/HeaderCell";
import FilterMenu from "../../components/form-controls/FilterMenu";
import messages from "../../helpers/messages";
import getSortOrder from "../../helpers/getSortOrder";
import {
  fetchAllBids,
  setColumnFilterMenu,
  setModeFilters,
  setSortParams,
  setStatusFilters,
  setColumnWidth
} from "../../slices/searchAllBidsSlice";
import { modeOptions, statusOptions } from "../../helpers/types";

const TableHeader = () => {
  const dispatch = useDispatch();
  const { isFetching, modes, status, sortColumn, sortOrder, columnFilterMenu, columnWidths } =
    useSelector(state => state.searchAllBids);

  const mapSelectedItems = (selectedItems, options) => {
    let opt = cloneDeep(options);
    if (selectedItems.length) {
      opt.map(o => {
        if (selectedItems.some(i => i.key === o.key)) {
          o.selected = true;
        }
        return o;
      });
    }
    return opt;
  };

  const modeItems = mapSelectedItems(modes, modeOptions);
  const statusItems = mapSelectedItems(status, statusOptions);

  const handleFilter = (items, field) => {
    if (field === messages.mode.defaultMessage) {
      dispatch(setModeFilters(items.filter(i => i.selected === true)));
    } else {
      dispatch(setStatusFilters(items.filter(i => i.selected === true)));
    }
    dispatch(fetchAllBids());
  };

  const sortBids = ({ fieldName }) => {
    const order = getSortOrder(fieldName, sortColumn, sortOrder);
    const sortParams = {
      sortColumn: order ? fieldName : "",
      sortOrder: order
    };
    dispatch(setSortParams(sortParams));
    dispatch(fetchAllBids());
  };

  const Filter = ({ label }) => (
    <Fragment>
      <span className="fr">
        <FilterMenu
          disabled={false}
          field={label}
          options={
            label === messages.status.defaultMessage ? statusItems : modeItems
          }
          handleFilter={handleFilter}
          show={() =>
            dispatch(setColumnFilterMenu({ field: label, visible: true }))
          }
          visible={columnFilterMenu.field === label && columnFilterMenu.visible}
          onClickOutside={() =>
            dispatch(setColumnFilterMenu({ field: null, visible: false }))
          }
        />
      </span>
    </Fragment>
  );
  const commonHeaderProps = columnName => ({
    sortBids,
    sortField: sortColumn,
    sortOrder,
    isFetching,
    resize: true,
    columnWidth: columnWidths[columnName] || "",
    setColumnWidth: width =>
      dispatch(
        setColumnWidth({ field: columnName, width})
      ),
    className: "m-0 p-0"
  });

  return (
    <thead data-testid="table-header">
      <tr className="header-row bg-white">
        <HeaderCell
          label={messages.uniqueBidName.defaultMessage}
          fieldName="BidName"
          {...commonHeaderProps("bidName")}
        />
        <HeaderCell
          label={messages.bidCreator.defaultMessage}
          {...commonHeaderProps("bidCreator")}
        />
        <HeaderCell
          label={messages.bidOwner.defaultMessage}
          {...commonHeaderProps("bidOwner")}
        />
        <HeaderCell
          label={messages.accountName.defaultMessage}
          fieldName="ShipperName"
          {...commonHeaderProps("shipperName")}
        />
        <HeaderCell
          label={messages.startDate.defaultMessage}
          fieldName="startDate"
          {...commonHeaderProps("startDate")}
          minWidth="90px"
        />
        <HeaderCell
          label={messages.endDate.defaultMessage}
          fieldName="endDate"
          {...commonHeaderProps("endDate")}
          minWidth={90}
        />
        <HeaderCell
          label={messages.mode.defaultMessage}
          isFilter={true}
          filter={Filter}
          {...commonHeaderProps("mode")}
          minWidth={90}
        />
        <HeaderCell
          label={messages.status.defaultMessage}
          isFilter={true}
          filter={Filter}
          {...commonHeaderProps("status")}
          resize={false}
        />
      </tr>
    </thead>
  );
};

export default TableHeader;
